import {useEffect} from 'react';

const savedPositions = {};

export const RestoreScrollPosition = (props) => {
  const {path, doneLoading} = props;
  if (!path) {
    evite.error('UseRestoreScrollPosition requires a path');
    return;
  }
  const [x, y] = savedPositions[path] || [0, 0];

  const handleScrollPosition = () => {
    if (window.location.pathname.toString().startsWith(path)) {
      savedPositions[path] = [window.scrollX, window.scrollY];
    } else {
      delete savedPositions[path];
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  useEffect(() => {
    window.scrollTo(x, y);
    return () => {
      handleScrollPosition();
    };
  }, [doneLoading]);
};
